import { Injectable } from '@angular/core';
import { DiscoverApiService, MetricResourceResponse, HttpOptions, CommonApiService } from 'polly-commons';
import { Observable } from 'rxjs';
import { IngestionRunAction } from '../../../modules/ingestion-module/@core/constants';
import { IngestionBatches, IngestionBatchSingleResponse, DownloadLogs, IngestionRuns, IngestionLogsResponse, PipelineBatch, IngestionRunActionPayload, IngestionRunSingleResponse, BatchUpdatePayload, BatchesInfo, DagResponse } from '../../../modules/ingestion-module/@core/interfaces';
import { PRAVAAH_API_ENDPOINT } from '../../../modules/pipelines-module/constants';

@Injectable({
  providedIn: 'root'
})
export class PollyManageDataMetricsService {
  constructor(
    private readonly discoverApiService: DiscoverApiService,
    private readonly commonApiService: CommonApiService
  ) { }

  public getTotalMetrics(): Observable<MetricResourceResponse> {
    return this.discoverApiService.get('metrics?v2=true');
  }

  public getRepoID(): number {
    if (window.location.hostname.includes('localhost')) {
      return 1622526550765;
    } else if (window.location.hostname.includes('devpolly')) {
      return 1657028057682;
    } else if (window.location.hostname.includes('testpolly')) {
      return 1622526550765;
    } else {
      return 1615965444377;
    }
  }

  public getRepoName(): string {
    if (window.location.hostname.includes('localhost')) {
      return 'liver_atlas';
    } else if (window.location.hostname.includes('devpolly')) {
      return 'liver_atlas';
    } else if (window.location.hostname.includes('testpolly')) {
      return 'liver_atlas';
    } else {
      return 'liveromix_atlas';
    }
  }

  public getIngestionBatches(queryParam: string): Observable<IngestionBatches> {
    return this.commonApiService.get(`${PRAVAAH_API_ENDPOINT.ORCHESTRATION}/batches?${queryParam}`);
  }

  public getNextBatchesData(url: string, queryParam: string): Observable<IngestionBatches> {
    return this.commonApiService.get(`${url}&${queryParam}`);
  }

  public getIngestionSingleBatch(selfLink: string): Observable<IngestionBatchSingleResponse> {
    return this.commonApiService.get(`${selfLink}`);
  }

  public getIngestionRuns(batchInfo: BatchesInfo, pageSize: number, filter?: string): Observable<IngestionRuns> {
    let runQuery: string = `${batchInfo.self_link}/runs?page[size]=${pageSize}&filter[batch_id]=${batchInfo.batch_id}`;
    runQuery += filter ? `&${filter}` : '';
    return this.commonApiService.get(runQuery);
  }

  public getPipelineDag(runId: string): Observable<DagResponse> {
    return this.commonApiService.get(`${PRAVAAH_API_ENDPOINT.ORCHESTRATION}/runs/${runId}/graph`)
  }

  public getIngestionSingleRun(runId: string): Observable<IngestionRunSingleResponse> {
    return this.commonApiService.get(`${PRAVAAH_API_ENDPOINT.ORCHESTRATION}/runs/${runId}`);
  }

  public getNextIngestionRuns(selfLink: string): Observable<IngestionRuns> {
    return this.commonApiService.get(`${selfLink}`);
  }

  public updateBatchDetails(id: string, payload: BatchUpdatePayload): Observable<IngestionBatchSingleResponse> {
    return this.commonApiService.patch(`${PRAVAAH_API_ENDPOINT.ORCHESTRATION}/batches/${id}`, payload);
  }

  public submitIngestionRunAction(runId: string, runAction: IngestionRunAction): Observable<PipelineBatch> {
    const httpOptions: HttpOptions = {
      headers: {
        'generate-api-key': '3',
      },
    };
    const url = `/connectors/runs/${runId}`;
    const payload: IngestionRunActionPayload = {
      data: {
        attributes: {
          action: runAction,
        },
        type: 'pipeline-action',
      },
    };
    return this.discoverApiService.post(url, payload, httpOptions);
  }

  public getIngestionLogs(pageSize: number, query: string, runId: string): Observable<IngestionLogsResponse> {
    let queryParam = `page[size]=${pageSize}&filter[run_id]=${runId}${query ? `&${query}` : ''}`;
    return this.commonApiService.get(`${PRAVAAH_API_ENDPOINT.ORCHESTRATION}/logs?${queryParam}`);
  }

  public getRunTaskLogs(runId: string, executionId: string, query?: string): Observable<IngestionLogsResponse> {
    const queryParam = query ? `&${query}` : '';
    return this.commonApiService.get(`${PRAVAAH_API_ENDPOINT.ORCHESTRATION}/runs/${runId}/graph/logs?filter[node_execution_id]=${executionId}${queryParam}`)
  }

  public cancelCurrentRun(runId: string): Observable<IngestionRunSingleResponse> {
    return this.commonApiService.post(`${PRAVAAH_API_ENDPOINT.ORCHESTRATION}/runs/${runId}/cancel`, '');
  }

  /* if runId is not provioded then it will generate query praram for downloading all dataset logs
  else it will only download logs for particular dataset*/
  public downloadLogs(urlLink: string, params: string): Observable<DownloadLogs> {
    return this.commonApiService.get(`${urlLink}/logs/actions/download?${params}`);
  }

  public downloadTaskLogs(runId: string, executionId: string): Observable<DownloadLogs> {
    return this.commonApiService.get(`${PRAVAAH_API_ENDPOINT.ORCHESTRATION}/runs/${runId}/graph/logs/download?filter[node_execution_id]=${executionId}`);
  }

  public resumeRun(runId: string): Observable<IngestionRunSingleResponse> {
    return this.commonApiService.post(`${PRAVAAH_API_ENDPOINT.ORCHESTRATION}/runs/${runId}/resume`,{});
  }

}
